module.exports = "<div class=\"anandtv_modal text-center\">\n  <div class=\"col-sm-12\">\n    <h2>Proceed payment</h2>\n    <p>Anand media</p>\n  </div>\n  <label class=\"checkoutanand\" type=\"number\"  style=\"padding-bottom: 10px;\">£ {{packageData.price}}</label>\n  <h2 *ngIf=\"paypalLoad\">Paypal button is loading</h2>\n  <div id=\"paypal-checkout-btn\"></div>\n  <div class=\"clearfix\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/payment.component.html
// module id = ./src/app/payment/payment.component.html
// module chunks = main